// extracted by mini-css-extract-plugin
export default {"price":"price-USK2"};